import {
  getAllocationRuleInvestingEntitiesRetrieveLoader,
  getAllocationRuleRetrieveLoader,
  getAllocationRuleVersionListLoader,
} from "gen/endpoints/allocation-rule/allocation-rule";
import { getEntityAllocationRulesRetrieveLoader } from "gen/endpoints/allocation-rule-lookup/allocation-rule-lookup";
import { getCommitmentInformationListLoader } from "gen/endpoints/commitment-information/commitment-information";
import i18n from "i18n/config";
import { RouteObject } from "react-router-dom";
import { composeLoaders } from "shared/utils/RoutingUtils";

export const createAllocationRoutes = (prefix: string): RouteObject => ({
  id: `${prefix}Allocations`,
  path: "allocations",
  children: [
    {
      id: `${prefix}AllocationsCreate`,
      path: "create",
      lazy: async () => {
        const { AllocationCreatePage } = await import(
          "features/allocations/AllocationCreatePage"
        );
        return { Component: AllocationCreatePage };
      },
    },
    {
      id: `${prefix}AllocationsEdit`,
      path: "edit/:allocationRuleId",
      lazy: async () => {
        const { AllocationEditPage } = await import(
          "features/allocations/edit/AllocationEditPage"
        );
        return { Component: AllocationEditPage };
      },
      children: [
        {
          id: `${prefix}AllocationsEditBasic`,
          path: "",
          lazy: async () => {
            const { AllocationEditTabDetails } = await import(
              "features/allocations/edit/AllocationEditTabDetails"
            );
            return { Component: AllocationEditTabDetails };
          },
          handle: {
            title: i18n.t("common:basicDetails"),
          },
          loader: getAllocationRuleRetrieveLoader(),
        },
        {
          id: `${prefix}AllocationsEditInvesting`,
          path: "entities",
          lazy: async () => {
            const { AllocationEditTabInvestingEntities } = await import(
              "features/allocations/edit/AllocationEditTabInvestingEntities"
            );
            return { Component: AllocationEditTabInvestingEntities };
          },
          handle: {
            title: i18n.t("allocation:investingEntities"),
          },
          loader: composeLoaders(
            getAllocationRuleInvestingEntitiesRetrieveLoader(),
            getEntityAllocationRulesRetrieveLoader(),
            getCommitmentInformationListLoader(),
            getAllocationRuleVersionListLoader(),
          ),
        },
      ],
    },
    {
      id: `${prefix}AllocationsSetup`,
      path: "setup/:allocationRuleId/*",
      lazy: async () => {
        const { AllocationSetupPage } = await import(
          "features/allocations/setup/AllocationSetupPage"
        );
        return { Component: AllocationSetupPage };
      },
      children: [
        {
          id: `${prefix}AllocationsSetupDetails`,
          lazy: async () => {
            const { AllocationSetupDetailsPage } = await import(
              "features/allocations/setup/AllocationSetupDetailsPage"
            );
            return { Component: AllocationSetupDetailsPage };
          },
          path: "",
          handle: {
            title: i18n.t("allocation:setup.details.title"),
          },
        },
        {
          id: `${prefix}AllocationsSetupEntities`,
          path: "entities",
          lazy: async () => {
            const { AllocationSetupEntitiesPage } = await import(
              "features/allocations/setup/AllocationSetupEntitiesPage"
            );
            return { Component: AllocationSetupEntitiesPage };
          },
          handle: {
            title: i18n.t("allocation:setup.entities.title"),
          },
        },
      ],
    },
  ],
});
